import { toActivityCostWithLocation } from './activity-cost.js';
import { toStudyContributor } from './biomedical-library-proxy.js';
import { checkPositiveNumber } from '../utils/checkPositiveNumber.js';
/**
 * Validates and normalizes the provided raw {@link ActivityTimeCost}
 * @param source The source object to convert from
 */
export function toActivityTimeCost(source) {
    const activityCostWithLocation = toActivityCostWithLocation(source);
    //Allow cost to be undefined; otherwise verify it to be positive int
    if (activityCostWithLocation.cost != null) {
        checkPositiveNumber(activityCostWithLocation.cost, 'ActivityTimeCost.cost');
    }
    return {
        ...activityCostWithLocation,
        studyContributor: toStudyContributor(source.studyContributor),
        sampleType: source.sampleType,
    };
}
//# sourceMappingURL=activity-time-cost.js.map